module.exports = __webpack_public_path__ + "static/profile-b637bf8fc80b6d7c49772e8177f21e22.jpg";